// Formant-staff dashboard of every org's human-approved robot onboarding
// plans — `/internal/robot-plans`. Filters (`range`, `org`, `status`, `q`,
// `cause`) live in the search params so views are shareable.
import { createFileRoute } from '@tanstack/react-router';

import { RobotPlansOverviewPage } from '../../../components/robot-plans/RobotPlansOverviewPage';
import { parseRobotPlansSearch } from '../../../components/robot-plans/robot-plans-model';
import { guardSuperuser } from '../index';

export const Route = createFileRoute('/internal/robot-plans/')({
  beforeLoad: () => guardSuperuser(),
  validateSearch: parseRobotPlansSearch,
  component: RobotPlansOverviewPage,
});
